import { Job, TaskType } from '../../../../../clients/quipli-service/job-tasks/job-tasks';
import { ProductInventoryUnit } from '../../../../../clients/quipli-service/product/product';
import Icon from '../../../../../components/icons/icon';
import { Typography } from '../../../../../components/typography/typography';

/**
 * Inspection status (to display on the order page), shows the status of the tasks for a given unit/inspection pair.
 * @param inspection - The inspection.
 * @param unit - The unit.
 */
export const InspectionStatus = ({ inspection, unit }: { inspection: Job; unit: ProductInventoryUnit }) => {
  const checklistTask = inspection.tasks.find(
    (t) => t.metadata?.productUnitId === unit.id && t.type === TaskType.InspectionChecklist,
  );

  return (
    <div className="flex gap-2 items-center">
      {checklistTask?.metadata?.checklist.some((item: any) => item.value === false) ? (
        <Icon icon="Warning" stroke="yellow" size="small" />
      ) : (
        <></>
      )}
      <div
        className={`flex items-center gap-2 ${
          inspection.tasks?.find((_) => _.metadata?.productUnitId === unit.id)?.status === 'Complete'
            ? inspection.tasks.find(
                (t) =>
                  t.metadata?.productUnitId === unit.id &&
                  t.type === TaskType.InspectionChecklist &&
                  t.metadata?.checklist.some((item: any) => item.value === false),
              )
              ? 'text-red-500'
              : 'text-green-500'
            : inspection.tasks?.find((_) => _.metadata?.productUnitId === unit.id)?.status === 'InProgress'
            ? 'text-yellow-500'
            : 'text-grey-500'
        }`}
      >
        <Typography type="text-sm" weight="semi-bold">
          {inspection.tasks?.find((_) => _.metadata?.productUnitId === unit.id)?.status === 'NotStarted'
            ? 'Not Started'
            : inspection.tasks?.find((_) => _.metadata?.productUnitId === unit.id)?.status === 'InProgress'
            ? 'In Progress'
            : `Complete${
                inspection.tasks.find(
                  (t) =>
                    t.type === TaskType.InspectionChecklist &&
                    t.metadata?.productUnitId === unit.id &&
                    t.metadata?.checklist.some((item: any) => item.value === false),
                )
                  ? ' - Not Passed'
                  : ''
              }`}
        </Typography>
      </div>
    </div>
  );
};
